// extracted by mini-css-extract-plugin
module.exports = {"root":"reason_root__1Uy1G","inner":"reason_inner__27LX-"};